import { CustomFieldEntity } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import CIMSSelect from 'components/CIMSSelect'

const EntityIdsFormItem: React.FC = () => {
  const options = useOptions({
    items: CustomFieldEntity.values,
    value: 'id',
    label: 'type',
    sort: 'type',
  })
  return (
    <CIMSFormItem
      name="entityIds"
      label="Record Link Types"
      requiredMessage="Please select at least one record link type"
      help={HelpMessage.Administration.CustomFields.RecordLinkTypes}
    >
      <CIMSSelect simple mode="multiple" options={options} />
    </CIMSFormItem>
  )
}

export default EntityIdsFormItem
